// @flow
import React from 'react';
import { addTranslationKeys } from 'Src/i18n';

import { ICONS } from 'Components/utils/icon/icons';

import { AccessAndMap } from 'Components/widgets/access-and-map/AccessAndMap';
import { LineTitle } from 'Components/widgets/line-title/LineTitle';
import { SiteContainer } from 'Components/frameworks/site-container/SiteContainer';

const ICON_MAPPING = {
  TRAIN_STATION: ICONS.TRAIN,
  AIRPORT: ICONS.TRANSPORT,
  PORT: ICONS.BOAT,
};

type Props = {
  accessTitle: string,
  config: CMSContent,
  mapType: 'GOOGLE' | 'BAIDU',
  minutes: string,
  resort: Resort,
  title?: string,
};

function buildAccess(minutes) {
  return ({ name, transfertDurationMin, type }) => {
    return type
      ? {
          iconName: ICON_MAPPING[type.toUpperCase()],
          texts: [name, transfertDurationMin ? `${transfertDurationMin} ${minutes}` : null].filter(
            Boolean,
          ),
        }
      : null;
  };
}

export const ProductAccessAndMapLine = (props: Props) => {
  const { accessTitle, config, mapType, minutes, resort = {}, title } = props;
  const accessesFiltered = resort.accesses.filter(
    access => access.id && !access.id.includes('MICE'),
  );

  addTranslationKeys(config);

  return (
    <SiteContainer className="Line">
      <LineTitle>{title}</LineTitle>
      <AccessAndMap
        accessTitle={accessTitle}
        access={[]
          .concat(accessesFiltered || [])
          .map(buildAccess(minutes))
          .filter(Boolean)}
        address={resort.address}
        isBaidu={mapType === 'BAIDU'}
        map={resort.coordinates}
        productName={resort.name}
        streetView={resort.streetView}
      />
    </SiteContainer>
  );
};
